import axios from "http/customAxios";
import qs from "qs";
import { IConfig } from "../../lib/config";

export class KeycloakApi {
  static async isValidUser(config: IConfig, username: string, password: string): Promise<void> {
    const url: string = `${config.keycloakUrl}/realms/${config.keycloakRealm}/protocol/openid-connect/token`;
    try {
      await axios({
        method: "post",
        url,
        data: qs.stringify({
          username,
          password,
          client_id: config.keycloakClientId,
          grant_type: "password",
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "*/*",
        },
      });
    } catch {
      // Never propagate the AxiosError: it carries the submitted password (config.data)
      // and the Authorization header, which would leak if the error is logged.
      throw new Error("Invalid credentials");
    }
  }
}
